"use client";

import { Flex, Text } from "@chakra-ui/react";
import { FiMoon, FiSun } from "react-icons/fi";
import { useDashboardTheme } from "@/components/dashboard/DashboardThemeProvider";
import { SidebarNavIcon } from "@/components/shared/sidebar/SidebarNavItemLabel";
import { Switch } from "@/components/shared/formElements/Switch";
import { useThemeTokens } from "@/lib/theme/tokens";

interface SidebarThemeToggleProps {
  isCollapsed?: boolean;
}

export const SidebarThemeToggle = ({
  isCollapsed = false,
}: SidebarThemeToggleProps) => {
  const { mode, toggleMode, canToggleTheme } = useDashboardTheme();
  const theme = useThemeTokens();

  if (!canToggleTheme) {
    return null;
  }

  const isDark = mode === "dark";

  return (
    <Flex
      align="center"
      justify={isCollapsed ? "center" : "space-between"}
      w="100%"
      px={isCollapsed ? 2 : 3}
      py={2}
      gap={3}
      data-testid="sidebar-theme-toggle"
    >
      {!isCollapsed && (
        <Flex align="center" gap={2.5} flex={1} minW={0}>
          <SidebarNavIcon
            as={isDark ? FiMoon : FiSun}
            color={theme.text.secondary}
          />
          <Text fontSize="sm" fontWeight="400" color={theme.text.secondary}>
            Dark mode
          </Text>
        </Flex>
      )}

      <Switch
        isChecked={isDark}
        onChange={() => toggleMode()}
        aria-label="Toggle dark mode"
      />
    </Flex>
  );
};
